import axios from "axios";
import store from "../store/index";
import { getExceptionMessage, API_BASE_URL } from "../utils/helper";
import { processResponse } from "./serviceUtil";
import pendingBcrActionTypes from "../actions/types/pendingBcr.action.type";

export const pendingBcrService = {
  getPendingBcrApprovals,
  approveOrRejectPendingBcr,
};

function getPendingBcrApprovals(searchValues, setLoading) {
  return (dispatch) => {
    const token = store.getState()?.loginUserReducer.token;

    axios
      .get(`${API_BASE_URL()}/bcr-pending-approvals/list`, {
        params: {
          status: searchValues.status,
          offset: searchValues.offset,
          limit: searchValues.limit,
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
      .then((res) => {
        dispatch({
          data: res.data?.data,
          totalCount: res.data?.count,
          searchValues,
          type: pendingBcrActionTypes.GET_PENDING_BCR_APPROVALS_SUCCESS,
        });
        if (setLoading) setLoading(false);
      })
      .catch((error) => {
        const parsedError = getExceptionMessage(error);
        dispatch({
          error: parsedError,
          type: pendingBcrActionTypes.GET_PENDING_BCR_APPROVALS_FAILURE,
        });
        if (setLoading) setLoading(false);
      });
  };
}

function approveOrRejectPendingBcr(pendingBcrRequest, props) {
  return (dispatch) => {
    const token = store.getState()?.loginUserReducer.token;

    axios
      .post(`${API_BASE_URL()}/bcr-pending-approvals/approve-reject`, pendingBcrRequest, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
      .then((res) => {
        dispatch({
          data: res.data,
          type: pendingBcrActionTypes.APPROVE_REJECT_PENDING_BCR_SUCCESS,
        });
        processResponse(true, props);
      })
      .catch((error) => {
        const parsedError = getExceptionMessage(error);
        dispatch({
          error: parsedError,
          type: pendingBcrActionTypes.APPROVE_REJECT_PENDING_BCR_FAILURE,
        });
        processResponse(false, props, parsedError);
      });
  };
}
